import React, {useEffect, useState} from 'react';
import {Alert, Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle} from '@mui/material';
import * as CommunicationService from '../../../services/CommunicationService';

export default function TeregoDocumentPreview({document, onClose}) {
    const [url, setUrl] = useState('');
    const [error, setError] = useState(false);
    const isPdf = /\.pdf$/i.test(document.internalName);

    useEffect(() => {
        let cancelled = false;
        let objectUrl;
        const load = async () => {
            try {
                const response = await CommunicationService.downloadFile(document.url);
                const content = await response.blob();
                if (cancelled) return;
                const extension = document.internalName.split('.').pop().toLowerCase();
                const type = {pdf: 'application/pdf', jpg: 'image/jpeg', png: 'image/png', webp: 'image/webp'}[extension];
                objectUrl = URL.createObjectURL(new Blob([content], {type}));
                setUrl(objectUrl);
            } catch (_) {
                if (!cancelled) setError(true);
            }
        };
        load();
        return () => {
            cancelled = true;
            if (objectUrl) URL.revokeObjectURL(objectUrl);
        };
    }, [document]);

    return <Dialog open fullWidth maxWidth="lg" onClose={onClose} aria-labelledby="terego-document-title">
        <DialogTitle id="terego-document-title" sx={{overflowWrap: 'anywhere'}}>{document.name}</DialogTitle>
        <DialogContent>
            {error ? <Alert severity="error">Documentul nu a putut fi deschis. Închideți și încercați din nou.</Alert>
                : !url ? <CircularProgress aria-label="Se încarcă documentul"/>
                : isPdf ? <Box component="iframe" src={url} title={document.name} sx={{width: '100%', height: '70vh', border: 0}}/>
                : <Box component="img" src={url} alt={document.name} sx={{display: 'block', width: '100%', maxHeight: '70vh', objectFit: 'contain'}}/>}
        </DialogContent>
        <DialogActions><Button onClick={onClose}>Închide</Button></DialogActions>
    </Dialog>;
}
